import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { UsersIndexRequest } from "./types/users/requests/UsersIndexRequest";
import { AuthUserModel } from "./types/authorisation/models/AuthUserModel";
import { CreateUserRequest } from "./types/residents/requests/CreateUserRequest";
import { UsersIndexResponse } from "./types/users/responses/UsersIndexResponse";
import { EditUserRequest } from "./types/users/requests/EditUserRequest";
import { SuccessResponse } from "./types/common/responses/SuccessResponse";

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: DynamicBaseQuery,
  endpoints: (builder) => ({
    getAllUsers: builder.query<UsersIndexResponse, UsersIndexRequest>({
      query: (params) => ({
        url: "/users",
        method: "GET",
        params,
      }),
    }),
    createUser: builder.mutation<AuthUserModel, CreateUserRequest>({
      query: (body) => ({
        url: `/users`,
        method: "POST",
        body,
      }),
    }),
    updateUser: builder.mutation<
      AuthUserModel,
      { user: number; body: EditUserRequest }
    >({
      query: ({ user, body }) => ({
        url: `/users/${user}`,
        method: "PUT",
        body,
      }),
    }),
    deleteUser: builder.mutation<SuccessResponse, { user: number }>({
      query: ({ user }) => ({
        url: `/users/${user}`,
        method: "DELETE",
      }),
    }),
    resendUserInvite: builder.mutation<SuccessResponse, { user: number }>({
      query: ({ user }) => ({
        url: `/users/${user}/resend-password-invitation`,
        method: "POST",
      }),
    }),
  }),
});
export const {
  useGetAllUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useResendUserInviteMutation,
} = usersApi;
